import { useContext, useEffect, useRef, useState } from "react";
import { fakeTableList as initialFakeTableList, schema } from "./parts";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { GlobalContext } from "../../context/globalContext";
import {
  httpAPI_ACC005,
  httpAPI_APP016,
  httpEmailAddressReregistrationNotificationUpdate,
} from "./api/request";
import { TkGetCode } from "../../utils/TkGetCode";
import { applyEvent, Prefectures, Status } from "../../assets/data/Constants";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { IAPI_ACC009_Request } from "../../type/apiType";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import { BusinessContext } from "../../context/businessContext";
import TkMemo from "../../components/molecules/TkMemo";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import "./_style.scss";
import _ from "lodash";

/**
 * SCRC010004 代行処理依頼詳細
 * @returns JSX.Element
 */
const SCRC010004 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const [stateFakeTableList, setStateFakeTableList] = useState(
    _.cloneDeep(initialFakeTableList)
  );
  const [tel, setTel] = useState("");
  const [fax, setFax] = useState("");
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [httpReq, setHttpReq] = useState<any>({});
  const [status, setStatus] = useState<ITkViewButtonJudgementStatus>();
  const [responseData, setResponseData] = useState<any>();
  const isNewApply = useRef(true);
  const memoData = useRef("");
  const memoCheck = useRef(false);
  const memoBodyList = useRef<any>([]);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;

  async function openingScreen() {
    try {
      const res = await httpAPI_ACC005({
        applyId: location?.state?.applyId,
      });

      if (res.resultCd === "I0000") {
        isNewApply.current =
          res.applyStatus === Status["届出待ち"] ||
          res.applyStatus === Status["差戻し一時保存"] ||
          !location.state?.applyId;

        let resArr = stateFakeTableList
          .map((item) => {
            switch (item.keyword) {
              case "mutualAidContractNumber":
                return { ...item, setDefaultValue: res.contractorNo };
              case "mutualAidPolicyholderName":
                return { ...item, setDefaultValue: res.contractorName };
              case "zipcode":
                return { ...item, setDefaultValue: res.zipcode };
              case "locationGroup":
                return {
                  ...item,
                  valueObject: {
                    prefectures: TkGetCode(Prefectures, res.prefectureCd) || "",
                    city: res.addressCity || "",
                    address: res.addressOthers || "",
                  },
                };
              case "personInChargeName":
                return { ...item, setDefaultValue: res.name };
              case "emailAddressUsedInThisSystem":
                return { ...item, setDefaultValue: res.email };
              case "emailAddressUsedInThisSystemForConfirmation":
                return { ...item, value: "", showLine: isNewApply?.current };
              case "contactPhoneNumber":
                return { ...item, setDefaultValue: res.tel };
              case "contactFAX":
                return { ...item, setDefaultValue: res.fax };
              case "others":
                return { ...item, setDefaultValue: res.notices };
              default:
                return item;
            }
          })
          .map((item) => {
            return { ...item, disabled: !isNewApply.current };
          });

        handleSetFakeTableList();

        const memoListData = res.processingStatusList?.map((item) => [
          { children: item.personnel },
          { children: item.processingStatus },
          { children: item.processingDate, align: "center" },
          { children: item.comment },
        ]);
        memoBodyList.current = memoListData;

        setStatus(res.applyStatus as ITkViewButtonJudgementStatus);
        setResponseData(res);
        setStateFakeTableList([...resArr]);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  }

  const handleSetFakeTableList = () => {
    let resArr = stateFakeTableList;
    let postcode = resArr.find((item) => item.keyword === "zipcode")!;
    let contactPhoneNumber = resArr.find(
      (item) => item.keyword === "contactPhoneNumber"
    )!;
    let contactFAX = resArr.find((item) => item.keyword === "contactFAX")!;

    // 住所検索
    postcode.getPostalCodeValue = (value: any) => {
      const data = value.value;

      let resObj = {
        prefectures: data.address1,
        city: data.address2,
        address: data.address3,
      };

      resArr.find((item) => item.keyword === "locationGroup")!.valueObject =
        resObj;

      setState({
        ...state,
        errorMsgId: "",
      });
    };

    postcode.getPostalCodeError = (value: any) => {
      setState({
        ...state,
        errorMsgId: value,
      });
    };

    contactPhoneNumber.onGetInputValue = (value: any) => {
      setTel(value.target.valueForShow);
    };

    contactFAX.onGetInputValue = (value: any) => {
      setFax(value.target.valueForShow);
    };
    setStateFakeTableList([...resArr]);
  };

  useEffect(() => {
    if (location?.state?.applyId) {
      openingScreen();
    } else {
      handleSetFakeTableList();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (data: any) => {
    if (
      data.emailAddressUsedInThisSystem !==
      data.emailAddressUsedInThisSystemForConfirmation
    ) {
      return setState({
        ...state,
        errorMsgId: "TKMSG_SCR0001E",
      });
    }
    setState({
      ...state,
      errorMsgId: "",
    });

    setHttpReq({ ...makeHttpObj(data) });
    setIsOpenDialog(true);
  };

  const makeHttpObj = (data: any): IAPI_ACC009_Request => {
    let reqObj: IAPI_ACC009_Request = {
      contractor_no: data.mutualAidContractNumber,
      corpName: data.mutualAidPolicyholderName,
      zipcode: data.zipcode,
      prefectureCd:
        Prefectures[data.locationGroup.prefectures as keyof typeof Prefectures],
      city: data.locationGroup.city,
      addressOthers: data.locationGroup.address,
      managerName: data.personInChargeName,
      email: data.emailAddressUsedInThisSystem,
      tel: tel,
      fax: fax,
      note: data.others,
    };

    return reqObj;
  };

  const handleOk = async () => {
    try {
      const res = await httpEmailAddressReregistrationNotificationUpdate({
        ...httpReq,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRC070008", { state: { endPoint: true } });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const clickJudge = async (btnName: keyof typeof applyEvent) => {
    const applyEventNo = applyEvent[btnName];
    if (
      ![
        applyEvent["受理"],
        applyEvent["契約者に差戻し"],
        applyEvent["上長承認"],
        applyEvent["担当者に差戻し"],
        applyEvent["課長代理確認"],
      ].includes(applyEventNo)
    )
      return;

    try {
      const res = await httpAPI_APP016({
        applyId: location.state?.applyId,
        applyEvent: applyEventNo,
        contractorNo: businessState.common?.contractorNo,
        reason: memoData.current,
        inquiryCode: memoCheck.current ? "1" : "",
        screenId: "SCRC010004",
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const memoChange = (event: any) => {
    switch (event.target.type) {
      case "input":
        memoData.current = event.target.value;
        break;
      case "checkbox":
        memoCheck.current = event.target.value;
        break;
    }
  };

  return (
    <Box className="SCRC010004" data-testid="SCRC010004PageForTest">
      {!isNewApply.current && isKiko && (
        <TkKikoStepper
          applicationFlowType={"TYPE3"}
          applicationStatus={
            responseData?.applyStatus as ITkViewButtonJudgementStatus
          }
        />
      )}

      <TkFakeTable
        list={stateFakeTableList}
        ruleSchema={schema}
        onCheckAndSubmit={handleSubmit}
        showButton={isNewApply.current}
      />

      {!isNewApply.current && isKiko && (
        <Box>
          <TkMemo
            bodyList={memoBodyList.current}
            showTable={true}
            onChange={memoChange}
          />
          <Box className="buttonGroup">
            <TkBackButton mr />
            <TkViewButtonJudgement
              flowType={"TYPE3"}
              Status={status as ITkViewButtonJudgementStatus}
              onClick={clickJudge}
            />
          </Box>
        </Box>
      )}
      <TkMessageDialog
        open={isOpenDialog}
        okText="はい"
        cancelText="いいえ"
        title="確認（機構へ提出する）"
        contextText="　機構へ提出を行いますが、問題ないでしょうか。"
        onOky={handleOk}
        onCancel={() => setIsOpenDialog(false)}
      />
    </Box>
  );
};

export default SCRC010004;
